import React from 'react'
import {Button} from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

 function BlockFifth() {

  let history = useHistory();

  const redirect = () => {
    history.push('/maketavimas')
    window.scrollTo(0, 0);
  }
    
    return (
    
     
      <div class="row treciasblokas sonai ">
      <div className="col-12 pav1 text-center text-dark"> <p> TINKLAPIŲ KŪRIMAS</p></div>
      <div className="col-12"> <hr className="text-white-50"/></div>
      <div className="col-12 pav2"> Diegiu WordPress ir Prestashop turinio valdymo sistemas, pritaikau prie kliento poreikių. SEO paslaugos</div>
          
      <div class="col-12 col-sm-6 col-md-6 col-lg-6 .col-xl-6 pb-4 ">
        <div class="thumbnail">
          <img  className="w-100"  src="pic/b3.png" alt="Nature" />
          <div class="caption text-center pt-4">
            <p>Įmonės ar asmeniniai tinklapiai </p>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-md-6 col-lg-6 .col-xl-6 pb-4">
        <div class="thumbnail">
          <img className="w-100" src="pic/b2.png" alt="Nature" />
          <div class="caption text-center pt-4">
            <p>Elektroninės parduotuvės</p>
          </div>
        </div>
      </div>

      <div class="col-md-12 text-center ">
        <Button className="button" onClick={redirect} variant="amber"  active type="submit">ATLIKTI DARBAI</Button>
       </div>       
      </div>
    )
}
export default BlockFifth